import { render, staticRenderFns } from "./SearchCompanyIds.vue?vue&type=template&id=2259c83b&scoped=true"
import script from "./SearchCompanyIds.vue?vue&type=script&lang=js"
export * from "./SearchCompanyIds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2259c83b",
  null
  
)

export default component.exports